import {ARTICLECHANGED,TITLECHANGED,FILTERBYSEARCH} from './actionsTypes'

export const articleChanged =(article)=>{
    return {
        type:ARTICLECHANGED,
        payload:article
    }
}

export const titleChanged =(title)=>{
    return {
        type:TITLECHANGED,
        payload:title
    }
}
export const filterBySearch =(search)=>{
    return {
        type:FILTERBYSEARCH,
        payload:search
    }
}